module.exports = __webpack_public_path__ + "static/media/coche.a49f6653.svg";